<template>
  <div class="News-area">
    <secBanner></secBanner>
    <el-container class="container content-area">
      <el-aside class="aside-area" width="260px">
        <ul>
          <li class="lead">新闻动态</li>
          <li>
            <router-link to="/news/company" active-class="cur"
              >公司新闻</router-link
            >
          </li>
          <li>
            <router-link to="/news/industry" active-class="cur"
              >行业动态</router-link
            >
          </li>
        </ul>
      </el-aside>
      <div class="sub-content-area">
        <div class="breadcrumb-nav">
          您的位置：
          <!-- <router-link to="/" title="首页">首页</router-link>> -->
          <router-link to="/news" title="新闻动态">新闻动态</router-link>
          <span>>&nbsp;{{ this.$route.name }}</span>
        </div>
        <router-view></router-view>
      </div>
    </el-container>
  </div>
</template>
<script>
import secBanner from "@/components/assembly/sec-banner";
export default {
  data() {
    return {};
  },
  components: {
    secBanner
  },
  mounted() {},
  methods: {
    getList() {
      this.$https
        .fetchPost("/Article/article_list", {
          classifyid: 13,
          page: 1,
          limit: 10
        })
        .then(res => {
          // console.log(res.data.data)
          this.newsList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/News.vue